import React from "react"

const MAX_SCORES = {
  admin1: 24000,
  admin2: 21000,
  "app-builder": 15000,
  "business-analyst": 18000,
  developer1: 12000,
}

const Resources = ({ score, activeCert, onRestart }) => {
  const maxScore = MAX_SCORES[activeCert] || 21000

  return (
    <>
      {score < maxScore * 0.75 ? (
        <div className="resourceContainer">
          <p className="resourceScore">
            Your Score: {((score / maxScore) * 100).toFixed(0)}%
          </p>
          <p className="resourceBody">
            Nice try but you'll need to keep working. Repetition is a key to
            learning.
          </p>
          <button onClick={onRestart} className="submit-button">
            Restart Game
          </button>
        </div>
      ) : score < maxScore * 0.9 ? (
        <div className="resourceContainer">
          <p className="resourceScore">
            Your Score: {((score / maxScore) * 100).toFixed(0)}%
          </p>
          <p className="resourceBody">
            Good Job! You're on track to successfully pass the exam!
          </p>
          <button onClick={onRestart} className="submit-button">
            Restart Game
          </button>
        </div>
      ) : (
        <div className="resourceContainer">
          <p className="resourceScore">
            Your Score: {((score / maxScore) * 100).toFixed(0)}%
          </p>
          <p className="resourceBody">
            Great Job! Let's increase your probability of passing that exam.
          </p>
          <button onClick={onRestart} className="submit-button">
            Restart Game
          </button>
        </div>
      )}
    </>
  )
}

export default Resources
